import useAuth from '@app/auth/use-auth';
import { OrganizationAccountTypeEnum } from '@shared/api/types';
import { SidebarInset } from '@shared/components/ui/sidebar';
import { Navigate, Outlet } from 'react-router-dom';
import { GroupSidebar } from './components/group-sidebar';

const GroupLayout = () => {
  const { user } = useAuth();

  if (!user) {
    return <Outlet />;
  }

  // Defence-in-depth: HomeRedirect already routes non-parent users away from
  // the group dashboard, but a deep link directly to /group/* shouldn't get in.
  if (user.organizationAccountType !== OrganizationAccountTypeEnum.parent) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <GroupSidebar />
      <SidebarInset className="h-full bg-gray-25">
        <Outlet />
      </SidebarInset>
    </>
  );
};

export default GroupLayout;
